import { getTileQuestionsAnswers } from '../answers.api';
import { TileQuestionsAnswers } from '../answers.types';

export const getRiskAssessmentTileQuestionsAnswers = async (
	clientId: string | number
): Promise<TileQuestionsAnswers> => {
	return getTileQuestionsAnswers(clientId, 'risk_assessment');
};
